import React from 'react';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import OrganizationDashboard from '../../components/OrganizationDashboard';

const TeamPage = () => {
  const { currentWorkspace, teamMembers, privacyMode } = useWorkspace();

  // Mock data for demo - this would come from your API
  const mockProjects = [
    {
      id: '1',
      name: 'Smith Wedding',
      client: 'John & Jane Smith',
      status: 'active',
      value: 3500,
      progress: 75,
      visibility: 'organization'
    },
    {
      id: '2',
      name: 'Corporate Headshots',
      client: 'Tech Corp',
      status: 'completed',
      value: 1200,
      progress: 100,
      visibility: 'organization'
    }
  ];

  const mockActivities = [
    {
      id: '1',
      type: 'project',
      user: { name: 'Sarah Johnson' },
      action: 'completed editing for',
      target: 'Smith Wedding Photos',
      timestamp: Date.now() - 300000,
      visibility: 'organization'
    },
    {
      id: '2',
      type: 'invoice',
      user: { name: 'Mike Chen' },
      action: 'created invoice for',
      target: 'Corporate Headshots ($1,200)',
      timestamp: Date.now() - 900000,
      visibility: 'organization'
    }
  ];

  const mockNotes = [
    {
      id: '1',
      content: 'Client requested additional retouching on wedding photos. Will need extra 2-3 hours.',
      author: { name: 'Sarah Johnson', initials: 'SJ' },
      timestamp: Date.now() - 1800000,
      visibility: 'organization'
    }
  ];

  const handleAddNote = (noteData) => {
    console.log('Adding note:', noteData);
    // This would typically call your API
  };

  if (!currentWorkspace || currentWorkspace.type !== 'organization') {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50 dark:bg-black">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            No Organization Selected
          </h2>
          <p className="text-gray-500 dark:text-[#666666]">
            Create or switch to an organization to view team features.
          </p>
        </div>
      </div>
    );
  }

  return (
    <OrganizationDashboard
      organization={currentWorkspace}
      privacyMode={privacyMode}
      currentUser={{ 
        id: 'current-user', 
        name: 'Current User', 
        initials: 'CU' 
      }}
      teamMembers={teamMembers}
      projects={mockProjects}
      activities={mockActivities}
      notes={mockNotes}
      onAddNote={handleAddNote}
    />
  );
};

export default TeamPage;